export const MainFunction = {
    checkDate(value) {
        if (!value) {
            return false;
        }
        let dateObj = value
        if (typeof value == "string") {
          if (!/^(?:[\+-]?\d{4}(?!\d{2}\b))(?:(-?)(?:(?:0[1-9]|1[0-2])(?:\1(?:[12]\d|0[1-9]|3[01]))?|W(?:[0-4]\d|5[0-2])(?:-?[1-7])?|(?:00[1-9]|0[1-9]\d|[12]\d{2}|3(?:[0-5]\d|6[1-6])))(?:[T\s](?:(?:(?:[01]\d|2[0-3])(?:(:?)[0-5]\d)?|24\:?00)(?:[\.,]\d+(?!:))?)?(?:\2[0-5]\d(?:[\.,]\d+)?)?(?:[zZ]|(?:[\+-])(?:[01]\d|2[0-3]):?(?:[0-5]\d)?)?)?)?$/.test(value)) {
            return false;
          }
          dateObj = new Date(value);
        }
        if (!dateObj || dateObj.constructor.name != "Date") {
          return false;
        }
        return true
    },
    shortDate(date) { //---------------- Ex 14/02/2566
        if (!MainFunction.checkDate(date)) {
            return ''
        }
        const dateMonthYear = new Intl.DateTimeFormat('th', { 
            year     : 'numeric',
            month    : '2-digit',
            day      : '2-digit',
            timeZone : 'Asia/Bangkok' 
        }).format(new Date(date))
        return `${dateMonthYear}`
    },
    fullDate(date) { //---------------- Ex 14 กุมภาพันธ์ 2566
        if (!MainFunction.checkDate(date)) {
            return ''
        }
        const dateMonthYear = new Intl.DateTimeFormat('th', {
            year     : 'numeric',
            month    : 'long',
            day      : 'numeric',
            timeZone : 'Asia/Bangkok'
        }).format(new Date(date))
        return `${dateMonthYear}` 
    },
    fullDateThTime(date) {//---------------- Ex  23 พฤษภาคม 2567 เวลา 23:40
        if (!MainFunction.checkDate(date)) {
            return '';
        }
        const dateTimeFormat = new Intl.DateTimeFormat('th-TH', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            timeZone: 'Asia/Bangkok'
        });
        const formattedDate = dateTimeFormat.format(new Date(date));
        return formattedDate;
    },
    fullDateEN(date) { //---------------- Ex 14 February 2023
        if (!MainFunction.checkDate(date)) {
            return ''
        }
        const dateMonthYear = new Intl.DateTimeFormat('en-uk', {
            year     : 'numeric',
            month    : 'long',
            day      : 'numeric',
            timeZone : 'Asia/Bangkok'
        }).format(new Date(date))
        return `${dateMonthYear}` 
    },
    shortTime(date) { //---------------- Ex 1:11 PM
        if (!MainFunction.checkDate(date)) {
            return ''
        }
        const hourMinute = new Intl.DateTimeFormat('th', {
            hour     : 'numeric',
            minute   : 'numeric',
            timeZone : 'Asia/Bangkok'
        }).format(new Date(date))
        return hourMinute
    },
    addComma(number) {
        function precision(no) {
            const length = no.length
            const dotIndex = no.indexOf('.')
            return length - (dotIndex + 1)
        }
        if(number.toString().includes('.')){
            return (new Intl.NumberFormat('th-TH',{
                minimumFractionDigits: precision(number.toString()),
                maximumFractionDigits: precision(number.toString())
            }).format(number.toString()))
        } else {
            return number.toLocaleString()
        }
    },
    roundUp(num) { return (Math.round(num * 100) / 100) },
}